import React, { ChangeEvent, useState } from 'react';
import { SPC_MOTOR_REQUEST } from '../../../constants';
import Button, { ButtonType } from '../../common/Button';
import { useHook } from '../../../hooks';
import { useAppSelector } from '../../../hooks/common';
import Loader from '../../common/Loader';
import { InnoButton } from '@innomotics/innomotics-build-react-lib';

const TestSpc = () => {
    const loading = useAppSelector(state => state.motor.loading);
    const [motorRequest, setMotorRequest] = useState(SPC_MOTOR_REQUEST);
    const { onSubmit } = useHook(x => x.testPage)();

    const onInputChange = (event: ChangeEvent<HTMLInputElement>) => setMotorRequest({ ...motorRequest, [event.target.name]: event.target.value });

    return (
        <Loader loading={loading}>
            <div className='test-page-container' onChange={onInputChange}>
                <div className='test-data-container'>
                    <div className='form-column'>
                        <div>
                            <label>Speed</label>
                            <input name='SU_CALCULATESPEED_1LE1X' value={motorRequest.SU_CALCULATESPEED_1LE1X} title='Speed' />
                        </div>
                        <div>
                            <label>SYNC speed</label>
                            <input name='SU_SYNCSPEED_1LE1HK' value={motorRequest.SU_SYNCSPEED_1LE1HK} title='SYNC speed' />
                        </div>
                        <div>
                            <label>Mlfb</label>
                            <input name='JOM_MLFB_123' value={motorRequest.JOM_MLFB_123} />
                        </div>
                        <div>
                            <label>Kag</label>
                            <input name='JOM_KAG_123' value={motorRequest.JOM_KAG_123} />
                        </div>
                        <div>
                            <label>Lang</label>
                            <input name='JOM_LANG' value={motorRequest.JOM_LANG} />
                        </div>
                        <div>
                            <label>Frequency</label>
                            <input name='SU_FREQUENCY_1LE1X' value={motorRequest.SU_FREQUENCY_1LE1X} title='Frequency' />
                        </div>
                        <div>
                            <label>Supply voltage</label>
                            <input name='SU_SUPPLYVOLTAGE_1LE1X' value={motorRequest.SU_SUPPLYVOLTAGE_1LE1X} title='Supply voltage' />
                        </div>
                        <div>
                            <label>Rated power</label>
                            <input name='SU_RATEDPOWER_1LE1X' value={motorRequest.SU_RATEDPOWER_1LE1X} title='Rated power' />
                        </div>
                        <div>
                            <label>Calculate power</label>
                            <input name='SU_CALCULATEPOWER_1LE1X' value={motorRequest.SU_CALCULATEPOWER_1LE1X} title='Calculate power' />
                        </div>
                        <div>
                            <label>Efficiency class</label>
                            <input name='SU_EFFICIENCYCLASS_1LE1HK' value={motorRequest.SU_EFFICIENCYCLASS_1LE1HK} title='Efficiency class' />
                        </div>
                        <div>
                            <label>Voltage code</label>
                            <input name='SU_VOLTAGECODE_1LE1HK' value={motorRequest.SU_VOLTAGECODE_1LE1HK} title='Voltage code' />
                        </div>

                        <div>
                            <label>Winding</label>
                            <input name='DE_SU_WINDING_1LE1HK' value={motorRequest.DE_SU_WINDING_1LE1HK} title='Winding' />
                        </div>
                        <div>
                            <label>Winding</label>
                            <input name='EN_SU_WINDING_1LE1HK' value={motorRequest.EN_SU_WINDING_1LE1HK} title='Winding' />
                        </div>

                        <div>
                            <label>AAD769</label>
                            <input name='DE_PMD_AAD769_001_000_HK1LE' value={motorRequest.DE_PMD_AAD769_001_000_HK1LE} title='AAD769' />
                        </div>

                        <div>
                            <label>AAA726</label>
                            <input name='PMD_AAA726_001_000_HK1LE' value={motorRequest.PMD_AAA726_001_000_HK1LE} title='AAA726' />
                        </div>
                        <div>
                            <label>AAA149</label>
                            <input name='PMD_AAA149_001_000_HK1LE' value={motorRequest.PMD_AAA149_001_000_HK1LE} title='AAA149' />
                        </div>
                        <div>
                            <label>AAF197</label>
                            <input name='PMD_AAF197_001_000_HK1LE' value={motorRequest.PMD_AAF197_001_000_HK1LE} title='AAF197' />
                        </div>
                        <div>
                            <label>AAF510</label>
                            <input name='PMD_AAF510_001_000_HK1LE' value={motorRequest.PMD_AAF510_001_000_HK1LE} title='AAF510' />
                        </div>
                        <div>
                            <label>ABV064</label>
                            <input name='PMD_ABV064_001_000_1010600' value={motorRequest.PMD_ABV064_001_000_1010600} title='ABV064' />
                        </div>
                        <div>
                            <label>ABV063</label>
                            <input name='PMD_ABV063_001_000_1010600' value={motorRequest.PMD_ABV063_001_000_1010600} title='ABV063' />
                        </div>
                        <div>
                            <label>ACN903(HeatingTimeT1T2)</label>
                            <input name='PMD_ACN903_001_000_1LE7' value={motorRequest.PMD_ACN903_001_000_1LE7} title='ACN903' />
                        </div>
                        <div>
                            <label>ACN904(HeatingTimeT3)</label>
                            <input name='PMD_ACN904_001_000_1LE7' value={motorRequest.PMD_ACN904_001_000_1LE7} title='ACN904' />
                        </div>
                        <div>
                            <label>TEMPKLASSE</label>
                            <input name='IN_TEMPKLASSE' value={motorRequest.IN_TEMPKLASSE} title='TEMPKLASSE' />
                        </div>
                        <div>
                            <label>Explosion Protection</label>
                            <input name='IN_ZONE' value={motorRequest.IN_ZONE} title='TEMPKLASSE' />
                        </div>
                        <div>
                            <label>Ausfuehrung</label>
                            <input name='DB_AUSFUEHRUNG_1LE1HK' value={motorRequest.DB_AUSFUEHRUNG_1LE1HK} title='Ausfuehrung' />
                        </div>
                        <div>
                            <label>ST2RTD torque</label>
                            <input name='SU_ST2RTDTORQUE_1LE1X' value={motorRequest.SU_ST2RTDTORQUE_1LE1X} title='ST2RTD torque' />
                        </div>
                        <div>
                            <label>Connection</label>
                            <input name='SU_CONNECTION_1LE1X' value={motorRequest.SU_CONNECTION_1LE1X} title='Connection' />
                        </div>
                        <div>
                            <label>BRK2RTD torque</label>
                            <input name='SU_BRK2RTDTORQUE_1LE1X' value={motorRequest.SU_BRK2RTDTORQUE_1LE1X} title='BRK2RTD torque' />
                        </div>
                    </div>
                    <div className='form-column'>
                        <div>
                            <label>Torque</label>
                            <input name='SU_CALCULATETORQUE_1LE1X' value={motorRequest.SU_CALCULATETORQUE_1LE1X} title='Torque' />
                        </div>
                        <div>
                            <label>Pullup torque</label>
                            <input name='SU_PULLUPTORQUE_1010600' value={motorRequest.SU_PULLUPTORQUE_1010600} title='Pullup torque' />
                        </div>
                        <div>
                            <label>Speedputorquerpm</label>
                            <input name='SU_SPEEDPUTORQUERPM_1LE1HK' value={motorRequest.SU_SPEEDPUTORQUERPM_1LE1HK} title='SPEEDPUTORQUERPM' />
                        </div>
                        <div>
                            <label>Udelta</label>
                            <input name='H_SU_UDELTA_1LE1HK' value={motorRequest.H_SU_UDELTA_1LE1HK} title='UDelta' />
                        </div>
                        <div>
                            <label>UY</label>
                            <input name='SU_UY_1LE1HK' value={motorRequest.SU_UY_1LE1HK} title='UY' />
                        </div>
                        <div>
                            <label>St2rtdcurrent</label>
                            <input name='SU_ST2RTDCURRENT_1LE1X' value={motorRequest.SU_ST2RTDCURRENT_1LE1X} title='ST2RTDCURRENT' />
                        </div>
                        <div>
                            <label>Idelta</label>
                            <input name='SU_IDELTA_1LE1HK' value={motorRequest.SU_IDELTA_1LE1HK} title='IDelta' />
                        </div>
                        <div>
                            <label>IY</label>
                            <input name='SU_IY_1LE1HK' value={motorRequest.SU_IY_1LE1HK} title='IY' />
                        </div>
                        <div>
                            <label>I0delta</label>
                            <input name='SU_I0DELTA_1LE1HK' value={motorRequest.SU_I0DELTA_1LE1HK} title='I0Delta' />
                        </div>
                        <div>
                            <label>I0y</label>
                            <input name='SU_I0Y_1LE1HK' value={motorRequest.SU_I0Y_1LE1HK} title='I0Y' />
                        </div>
                        <div>
                            <label>Inertia torque</label>
                            <input name='SU_INERTIATORQUE_1LE1X' value={motorRequest.SU_INERTIATORQUE_1LE1X} title='Inertia torque' />
                        </div>
                        <div>
                            <label>Startup type</label>
                            <input name='SU_STARTUPTYPE_1LE1X' value={motorRequest.SU_STARTUPTYPE_1LE1X} title='Startup type' />
                        </div>
                        <div>
                            <label>Typical curr</label>
                            <input name='SU_TYPICALCURR_1LE1X' value={motorRequest.SU_TYPICALCURR_1LE1X} title='Typical curr' />
                        </div>
                        <div>
                            <label>YD switch</label>
                            <input name='SU_STARTUP_YD' value={motorRequest.SU_STARTUP_YD} title='YD switch' />
                        </div>
                        <div>
                            <p key='text-align: center; font-weight: bold;'>VSD related fields</p>
                        </div>
                        <div>
                            <label>Is Dol Operation</label>
                            <input name='SU_VSD_DOL_TRIGGER_1LE1X' value={motorRequest.SU_VSD_DOL_TRIGGER_1LE1X} title='Is DOL operation' />
                        </div>
                        <div>
                            <label>Is Vsd Operation</label>
                            <input name='SU_VSD_VSD_TRIGGER_1LE1X' value={motorRequest.SU_VSD_VSD_TRIGGER_1LE1X} title='Is VSD operation' />
                        </div>
                        <div>
                            <label>Framesize 63 - 450</label>
                            <input name='PMD_AAD450_001_000_HK1LE' value={motorRequest.PMD_AAD450_001_000_HK1LE} title='Framesize 63 - 450' />
                        </div>
                        <div>
                            <label>Self ventilated</label>
                            <input name='PMD_AAA136_001_000_HK1LE' value={motorRequest.PMD_AAA136_001_000_HK1LE} title='Ventilation IC411 or IC416' />
                        </div>
                        <div>
                            <label>Rated Speed</label>
                            <input name='SU_VSD_SPEED_1LE1X' value={motorRequest.SU_VSD_SPEED_1LE1X} title='Rated Speed' />
                        </div>
                        <div>
                            <label>Rated Torque</label>
                            <input name='SU_VSD_TORQUE_1LE1X' value={motorRequest.SU_VSD_TORQUE_1LE1X} title='Rated Torque' />
                        </div>
                        <div>
                            <label>Cutoff Frequency</label>
                            <input name='SU_VSD_FREQUENCY_1LE1X' value={motorRequest.SU_VSD_FREQUENCY_1LE1X} title='Cutoff Frequency' />
                        </div>
                    </div>
                </div>
                <div className='form-submit'>
                    <InnoButton variant='primary' onClick={() => onSubmit(motorRequest)}>
                        <div>CALL SPC</div>
                    </InnoButton>
                </div>
            </div>
        </Loader>
    );
};

export default TestSpc;
